'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNewThread = createNewThread;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _reduxActions = require('redux-actions');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _createVisitorThread = require('../clients/createVisitorThread');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _getMessageId = require('../../selectors/pubNubMessageSelectors/getMessageId');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _visitorThreadCreated = require('../actions/visitorThreadCreated');

var _actionTypes = require('../constants/actionTypes');

var _isCreatingThread = require('../selectors/isCreatingThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actionTypes = (0, _makeRequestActionTypes.makeRequestActionTypes)(_actionTypes.CREATE_NEW_THREAD);
var createNewThreadAction = (0, _reduxActions.createAction)(actionTypes.STARTED);
var createNewThreadSucceeded = (0, _reduxActions.createAction)(actionTypes.SUCCEEDED);
var createNewThreadFailed = (0, _reduxActions.createAction)(actionTypes.FAILED);

function createNewThread() {
  return function (dispatch, getState) {
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var messageId = (0, _getMessageId.getMessageId)(getState());

    if ((0, _isCreatingThread.isCreatingThread)(getState())) return _q2.default.Promise.resolve();

    dispatch(createNewThreadAction());
    return (0, _createVisitorThread.createVisitorThread)({
      sessionId: sessionId,
      messageId: messageId
    }).then(function (res) {
      var channel = res.channel,
          id = res.id;


      return dispatch((0, _visitorThreadCreated.visitorThreadCreated)({ channel: channel, threadId: id })).then(function () {
        dispatch((0, _trackInteraction.trackInteraction)('start-conversation', {
          action: 'new conversation started',
          threadId: id
        }));
        return dispatch(createNewThreadSucceeded());
      });
    }, function () {
      return dispatch(createNewThreadFailed());
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/threads/actions/createNewThread.js
// module id = 644
// module chunks = 2 3